import React from 'react'
import * as Dropdown from 'component/base/Form/Dropdown'

export const YumekukanKeijibanKbn = props => {
  return <Dropdown.Static kubunKey='yumekukan_keijiban_kbn' {...props} />
}
